.player {
	display: flex;
	flex-direction: column;
	border-radius: 10px;
	overflow: hidden;
	/* background-color: #17171d; */
}

/* Fixed height (not an aspect-ratio) so this matches AudioRecordingQuestion.module.css's
.audioRecordingBoxVideoFill exactly — the live recording preview and this completed-state playback
area must be the same size, or the box visibly jumps/resizes the moment recording finishes. */
.mediaAreaVideo {
	position: relative;
	height: 260px;
	background-color: #000000;
}

/* In fullscreen, .player itself becomes the fullscreen element and grows to fill the viewport, but a
fixed 260px child doesn't grow with it — this let the video stay pinned at its normal small size with
a huge empty area below. flex: 1 instead makes it claim whatever space the seekbar/control bar (below)
don't need, i.e. the entire viewport height.

min-height: 0 is required alongside it — a flex item defaults to min-height: auto, which for an item
containing a <video> resolves to the video's *intrinsic* pixel height (e.g. 1080px for a 1080p
recording). Without overriding that, the item refuses to shrink below the video's native size, forcing
it taller than the viewport and pushing the seekbar/control bar below the fold entirely. */
.mediaAreaVideoFullscreen {
	height: auto;
	min-height: 0;
	flex: 1;
}

.mediaAreaAudio {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	min-height: 260px;
	padding: 24px;
	background-color: #1b1c20;
	text-align: center;
}

/* Same fix as .mediaAreaVideoFullscreen — a fixed min-height doesn't grow when .player becomes the
fullscreen element, leaving the poster pinned at its normal small size with empty space below. */
.mediaAreaAudioFullscreen {
	min-height: 0;
	flex: 1;
}

/* Scale the poster icon/text up in fullscreen — otherwise they stay tiny in the middle of a much
larger area. Keyed off .mediaAreaAudioFullscreen (already applied above) rather than a separate
className on the icon/text themselves. */
.mediaAreaAudioFullscreen .audioPoster svg {
	width: 180px;
	height: auto;
}

.mediaAreaAudioFullscreen .audioPosterHint {
	font-size: 20px;
	margin-top: 25px;
}

.video {
	width: 100%;
	height: 100%;
	display: block;
	object-fit: cover;
}

/* Hiding a <video> element doesn't stop its audio track — audio mode keeps this element mounted and
playing, but shows the poster below instead of a (blank) video frame. */
.videoHiddenForAudio {
	display: none;
}

.audioPoster {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
}

.audioPosterHint {
	font-size: 14px;
	color: #bcbcbc;
	margin: 0;
	margin-top: 10px;
}

.cornerAction {
	position: absolute;
	top: 12px;
	right: 12px;
	z-index: 1;
}

/* PlayOverlay's circle has a 50px margin-bottom baked in — tuned to sit above a large session video's
own bottom control bar. In this much smaller player it just pushes the icon noticeably off-center.
Passed in via PlayOverlay's circleClassName prop. */
.playOverlayCircleCompact {
	margin-bottom: 0;
}

/* Groups the seekbar and the button row into one attached unit below the media area, distinct from
QuestionAttemptSeekbar/VideoControlLayout's own (separately-styled) backgrounds. */
.controlsBox {
	display: flex;
	flex-direction: column;
	padding-bottom: 10px;
	border: 1px solid #404040;
	background-color: #17171d;
	z-index: 1;
}

/* :has(.fs) doesn't work here — .fs is scoped per CSS module, so the "fs" hash VideoControls.module.css
applies via addFullScreenClass is never the same string this file would compile ".fs" to. Driven off
the isFullscreen state directly instead (see RecordingPlaybackPlayer.tsx). */
.controlsBoxFullscreen {
	border: none;
	border-top: 1px solid #404040;
	padding-bottom: 0;
	padding-top: 10px;
	z-index: 1;
}

/* VideoControlLayout's default height/padding is sized for the full session-review player — taller
than this compact recording-review bar needs. Passed in via VideoControlLayout's className prop. */
.controlLayoutCompact {
	min-height: 32px;
}
